



export const utilMixin = {

	computed: {

		

	},

	methods: {

		copyToClipBoard(text) {
			if (navigator.clipboard) {

				navigator.clipboard.writeText(text);
				alert("Kopierade: " + text);
			}

		},

		copyToClipBoardNoAlert(text) {
			if (navigator.clipboard) {
			navigator.clipboard.writeText(text);
			}
		},



	}
}



